// extracted by mini-css-extract-plugin
export default {"arrow_left":"Arrow_arrow_left__355oc","arrow_down":"Arrow_arrow_down__BYiwA","arrow_up":"Arrow_arrow_up__Q7eSC","arrow_right":"Arrow_arrow_right__ycQRB"};